import { styled, Box, FormControl } from '@mui/material';

export const DurationBadge = styled('span')(() => ({
  padding: '2px 8px',
  borderRadius: '12px',
  color: '#555',
  fontSize: '12px',
  fontWeight: 500,
  border: '1px solid #BDBDBD',
  lineHeight: 1.4,
}));

export const StatusBadge = styled('span')<{ color: string }>(({ color }) => ({
  display: 'inline-block',
  padding: '4px 12px',
  borderRadius: '16px',
  backgroundColor: color,
  color: '#fff',
  fontSize: '12px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
}));

export const CircleBadge = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: 'white',
  borderRadius: '50%',
  width: 20,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 12,
  fontWeight: 'bold',
  lineHeight: 1,
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginRight: theme.spacing(2),
  minWidth: 64,
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

export const TimeText = styled('time')(() => ({
  display: 'inline-block',
  whiteSpace: 'nowrap',
}));

export const TruncatedEmail = styled('span')(() => ({
  display: 'block',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  verticalAlign: 'bottom',
}));
